"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactHotkeys = require("react-hotkeys");

var _reactTooltip = _interopRequireDefault(require("react-tooltip"));

var _preloader = require("../../../helpers/preloader/preloader.effect");

var _slider = _interopRequireDefault(require("../../../slider/slider"));

var _playerActionTypes = _interopRequireDefault(require("../player-action-types"));

// volume is considered high on and above this point, below that it's low or muted on 0
const VOLUME_STEP = 0.05;
const HIGH_VOLUME_LEVEL = 0.6;
const [mute, low, high, unmute] = ['mute', 'low', 'high', 'unmute'];

const Volume = ({
  videoTag,
  callbacks,
  showSlider,
  onInteraction,
  onShortcutChange,
  texts,
  hasToolTip,
  muted
}) => {
  const [volume, setVolume] = (0, _react.useState)(muted ? 0 : videoTag.volume);
  const volumeBeforeMute = (0, _react.useRef)(null);
  const tooltipMessages = {
    [unmute]: texts.unmute,
    [mute]: texts.mute
  };
  const [tooltipMessage, setTooltipMessage] = (0, _react.useState)('Mute (m)');

  function changeVolume(newVolume) {
    changeVideoVolume(newVolume);
    setVolume(newVolume); // reset stored volume on any change except mute

    if (newVolume > 0) {
      volumeBeforeMute.current = null;
    }
  }

  function toggleMute() {
    if (videoTag.volume > 0) {
      // mute and store volume level so we can restore to it after unmute
      volumeBeforeMute.current = videoTag.volume;
      changeVolume(0);
      setTooltipMessage(tooltipMessages[unmute]);
    } else {
      // restoring from mute
      const restoredVolume = Number.isFinite(volumeBeforeMute.current) ? volumeBeforeMute.current : 1;
      changeVolume(restoredVolume);
      setTooltipMessage(tooltipMessages[mute]);
    }
  }

  function beforeChange() {
    setDragging(true);
    callbacks.onBeforeChange && callbacks.onBeforeChange();
  }

  function changeVideoVolume(newVolume) {
    videoTag.volume = newVolume;
    callbacks.onVolumeChange && callbacks.onVolumeChange(newVolume);
    onInteraction();
  }

  let volumeGroup = volume === 0 ? mute : low;

  if (volume >= HIGH_VOLUME_LEVEL) {
    volumeGroup = high;
  }

  const control = (0, _react.useRef)(null);
  (0, _preloader.usePreloader)(control); // temporarily disable volume slider to force it to 'blur' if its active while mouseleave happens

  const [hoveredSlider, setSliderHover] = (0, _react.useState)(false);
  const [isDragging, setDragging] = (0, _react.useState)(false); // hotKeys

  const keyMap = {
    // temporaily disable up/down because they interfere with page scrolling
    // INCREMENT_VIDEO_VOLUME: { sequence: 'up', action: 'keypress' },
    // DECREMENT_VIDEO_VOLUME: { sequence: 'down', action: 'keypress' },
    MUTE_VIDEO_VOLUME: ['m', 'M']
  };
  const handlers = {
    INCREMENT_VIDEO_VOLUME: () => {
      const newVolume = videoTag.volume + VOLUME_STEP;

      if (newVolume <= 1) {
        changeVolume(newVolume);
        onShortcutChange(_playerActionTypes.default.VOLUME_UP);
      } else {
        changeVolume(1);
      }

      onInteraction();
    },
    DECREMENT_VIDEO_VOLUME: () => {
      const newVolume = videoTag.volume - VOLUME_STEP;

      if (newVolume >= 0) {
        changeVolume(newVolume);
        onShortcutChange(_playerActionTypes.default.VOLUME_DOWN);
      } else {
        changeVolume(0);
        onShortcutChange(_playerActionTypes.default.MUTE);
      }

      onInteraction();
    },
    MUTE_VIDEO_VOLUME: event => {
      event.preventDefault();
      toggleMute();

      if (videoTag.volume === 0) {
        onShortcutChange(_playerActionTypes.default.MUTE);
      } else {
        onShortcutChange(_playerActionTypes.default.VOLUME_UP);
      }
    }
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('volume-control', {
      'volume-control--show-slider': isDragging || hoveredSlider
    }),
    ref: control,
    onMouseEnter: () => setSliderHover(true),
    onMouseLeave: () => setSliderHover(false)
  }, /*#__PURE__*/_react.default.createElement(_reactHotkeys.GlobalHotKeys, {
    keyMap: keyMap,
    handlers: handlers
  }), hasToolTip && /*#__PURE__*/_react.default.createElement(_reactTooltip.default, {
    id: "volume-tooltip",
    class: "volume-control__tooltip",
    effect: "solid",
    getContent: () => tooltipMessage
  }), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: (0, _classnames.default)('volume-control__toggle', {
      'volume-control__toggle--mute': volumeGroup === mute,
      'volume-control__toggle--low': volumeGroup === low,
      'volume-control__toggle--high': volumeGroup === high
    }),
    onClick: toggleMute,
    "data-tip": "",
    "data-for": "volume-tooltip"
  }), showSlider && /*#__PURE__*/_react.default.createElement("div", {
    className: "volume-control__slider"
  }, /*#__PURE__*/_react.default.createElement(_slider.default, {
    theme: "monochrome",
    min: 0,
    max: 1,
    step: VOLUME_STEP,
    value: volume,
    onBeforeChange: beforeChange,
    onAfterChange: () => {
      setDragging(false);
    },
    onChange: changeVolume
  })));
};
/* eslint-disable react/no-unused-prop-types */


Volume.propTypes = {
  videoTag: _propTypes.default.instanceOf(global.Element),
  container: _propTypes.default.instanceOf(global.Element),
  callbacks: _propTypes.default.shape({
    onInit: _propTypes.default.func,
    onVolumeChange: _propTypes.default.func,
    onFullscreen: _propTypes.default.func,
    setIndicatorAction: _propTypes.default.func,
    onBeforeChange: _propTypes.default.func
  }),
  onShortcutChange: _propTypes.default.func,
  showSlider: _propTypes.default.bool,
  muted: _propTypes.default.bool,
  onInteraction: _propTypes.default.func.isRequired,
  texts: _propTypes.default.shape({
    unmute: _propTypes.default.string,
    mute: _propTypes.default.string
  }),
  hasToolTip: _propTypes.default.bool
};
/* eslint-enable react/forbid-prop-types */

Volume.defaultProps = {
  videoTag: null,
  container: null,
  callbacks: {},
  showSlider: true,
  muted: false,
  onShortcutChange: () => {},
  texts: {
    unmute: 'Unmute (m)',
    mute: 'Mute (m)'
  },
  hasToolTip: false
};
var _default = Volume;
exports.default = _default;